namespace advisorop.components.investor {

    interface IInvestorAppController {
    }

    class InvestorAppController implements IInvestorAppController {
        landingpage;
        generalService: services.GeneralService;

        static $inject = ["$location", "generalService"];
        constructor(private $location: ng.ILocationService, generalService: services.GeneralService) {
            this.generalService = generalService;
        }

        $onInit(): void {
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "landingpage") {
                    if (this.landingpage && this.generalService.goToLandingPage) {
                        this.$location.path('investor' + this.landingpage);
                        this.generalService.goToLandingPage = false;
                    }
                }
            }
        }

        $routerOnActivate(next, previous) {
            //console.log("routeOnActive Investor", next, previous, this.landingpage);
        }
    }



    class InvestorApp implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                landingpage: '@',
                "$router": '<',
                //textBinding: '@',
                //dataBinding: '<',
                //functionBinding: '&'
            };
            this.controller = InvestorAppController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/investor-module/components/investor-app.html';

            this.$routeConfig = [
                { path: "/dashboard", component: "investorDashboard", name: "Dashboard" },
                { path: "/householddashboard/:householdId", component: "invHhDashboard", name: "HouseholdDashboard" },
                { path: "/rtgdashboard/:rtgId", component: "invRtgDashboard", name: "RtgDashboard" },
                { path: "/adgdashboard/:groupId", component: "invAdgDashboard", name: "AdgDashboard" },
                { path: "/userprofile", component: "userProfile", name: "UserProfile" },
                //investment reports
                { path: "/investmentreports/:id/:ppLevel/:tabId", component: "invInvestmentReports", name: "InvestmentReports" },
                { path: "/**", redirectTo: ["Dashboard"] }
            ];
        }
    }
    angular.module(Constants.APP).component("investorApp", new InvestorApp());


}